import { Component, OnInit, Input } from '@angular/core';
import { TypeModal } from '../dashboard-monitor/dashboard-monitor.component';

@Component({
  selector: 'app-modals-monitor',
  templateUrl: './modals-monitor.component.html',
  styleUrls: ['./modals-monitor.component.scss']
})
export class ModalsMonitorComponent implements OnInit {

  @Input() modalRef : any;
  @Input() title : string;
  @Input() typeModal : number;

  typeModalReference = TypeModal;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/admin/monitor-agents/modals-monitor/modals-monitor.component.ts